import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { RouterModule } from '@angular/router';

import { IconComponent } from '@atoms/icon/icon.component';

@Component({
  selector: 'app-button',
  imports: [NgTemplateOutlet, RouterModule, IconComponent],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit, OnChanges {
  @Input() type: 'button' | 'submit' | 'link' = 'button';
  @Input() size: 'small' | 'small-medium' | 'medium' | 'large' = 'medium';
  @Input('size-sm') sizeSm?: 'small' | 'medium' | 'large';
  @Input() color: 'primary' | 'secondary' | 'light' | 'important' = 'primary';
  @Input() fullsize?: boolean;
  @Input('fullsize-sm') fullsizeSm?: boolean;
  @Input() align?: 'left' | 'center' | 'right';
  @Input() bold?: boolean;
  @Input('font-medium') fontMedium?: boolean;
  @Input() outlined?: boolean;
  @Input('outline-width') outlineWidth?: 'default' | 'thin' = 'default';
  @Input() disabled?: boolean;
  @Input() href?: string;
  @Input() target: string = '';
  @Input() route?: string | any[];
  @Input() params?: { [key: string]: any };
  @Input() fragment?: string;
  @Input('prevent-default') preventDefault?: boolean;
  @Input() multiselect?: boolean;
  @Output() clicked: EventEmitter<void> = new EventEmitter<void>();
  public classes: string = '';

  click(e: Event): void {
    if (this.preventDefault) e.preventDefault();
    this.clicked.emit();
  }

  setClasses(): void {
    const classes: string[] = [];
    classes.push(`button--${this.size}`);
    classes.push(`button--${this.color}`);
    if (this.sizeSm) classes.push(`button--sm-${this.sizeSm}`);
    if (this.align) classes.push(`button--${this.align}`);
    if (this.bold) classes.push('button--bold');
    if (this.fontMedium) classes.push('button--font-medium');
    if (this.outlined) classes.push('button--outlined');
    if (this.outlined && this.outlineWidth === 'thin') classes.push('button--outline-thin');
    if (this.disabled) classes.push('button--disabled');
    if (this.fullsize) classes.push('button--fullsize');
    if (this.fullsizeSm) classes.push('button--sm-fullsize');
    this.classes = classes.join(' ');
  }

  ngOnInit(): void {
    if (this.route || this.href) this.type = 'link';
    this.setClasses();
  }

  ngOnChanges(): void {
    this.setClasses();
  }
}
